import { useQuery } from "@tanstack/react-query";
import { getDecizieInregistrare } from "@/api/endpoints/decizieInregistrare";
import { queryKeys } from "@/lib/queryClient";

export function useGetDecizieInregistrare(
  sessionId: string | null,
  options?: { enabled?: boolean; retry?: boolean | number }
) {
  return useQuery({
    queryKey: queryKeys.decizieInregistrare.bySession(sessionId!),
    queryFn: () => getDecizieInregistrare(sessionId!),
    enabled: (options?.enabled ?? true) && !!sessionId,
    ...(options?.retry !== undefined && { retry: options.retry }),
  });
}
